import React from 'react';
import ReactDom from 'react-dom';
//import 'bootstrap/src/css/bootstrap.min.css'; 
//import 'bootstrap/scss/bootstrap.scss'; 
import CofiguratorApp from "./components/CofiguratorApp";
import {Config, Dictionary, Store, Error4Admin, helper} from "./app.js";

window.onerror = function(message, url, line, col, error) 
{
    console.error(message, url, line, col, error); /*      
    ReactDom.render(
        <AlertModal on_close='' message='При работе приложения произошла ошибка, попробуйте перезагрузить страницу' />,
        document.getElementById('system_error')
    );*/
};

window.globals = 
{
    _devtools: helper._devtools,
    _configurator: null,
    _project: null
}

Config.instance.init()
    .then((config) => 
    {
        Promise
            .all([
                Dictionary.instance.init(),
                Store.instance.get('project'), 
                Store.instance.get('configurator')        
            ])
            .then(function (results)
            {
                const [, project, configurator] = results,
                    folderPath = config.get('folder_path', location.pathname);
        
                ReactDom.render(
                    <CofiguratorApp folder_path={folderPath} init_project={project} init_configurator={configurator} />, 
                    document.getElementById('configurator_app')
                ); 
            });            
    })
    .catch(function (error)
    {
        if (error instanceof Error4Admin) 
        {
            console.error(error);
            alert('При загрузке приложения произошла ошибка!');
        }
        else 
            alert(error);/*
        
        ReactDom.render(
            <AlertModal on_close='' message={error} />,
            document.getElementById('system_error')
        );*/
    }); 
    